import { Duration } from '../configs/dayjs';

export const dayjsDurationFormat = (durationObj: Duration): string => {
	const hours = durationObj.hours();
	const minutes = durationObj.minutes();
	const seconds = durationObj.seconds();
	const milliseconds = durationObj.milliseconds();

	if (hours >= 1 && hours <= 23) {
		if (minutes === 0 && seconds === 0) {
			if (milliseconds === 0) {
				return `${hours}h`;
			}
		} else if (minutes >= 1 && seconds === 0) {
			if (milliseconds === 0) {
				return `${hours}h ${minutes}m`;
			}
		} else {
			if (milliseconds === 0) {
				return `${hours}h ${minutes}m ${seconds}s`;
			}
		}
		return `${hours}h ${minutes}m ${seconds}s ${milliseconds}ms`;
	}

	if (minutes >= 1 && minutes <= 59) {
		if (seconds === 0) {
			if (milliseconds === 0) {
				return `${minutes}m`;
			}
		} else {
			if (milliseconds === 0) {
				return `${minutes}m ${seconds}s`;
			}
		}
		return `${minutes}m ${seconds}s ${milliseconds}ms`;
	}

	if (seconds >= 1 && seconds <= 59) {
		if (milliseconds === 0) {
			return `${seconds}s`;
		}
		return `${seconds}s ${milliseconds}ms`;
	}

	return `${milliseconds}ms`;
};
